import { createAction, props } from '@ngrx/store';
import { User } from 'src/app/core/models/user.model';

export const login = createAction(
  '[Account] Login',
  props<{ provider: string, credentials?: any }>()
);

export const loginSuccess = createAction(
  '[Account] Login Success'
);

export const loginFailure = createAction(
  '[Account] Login Failure',
  props<{ error: any }>()
);

export const signUp = createAction(
  '[Account] Sign Up',
  props<{ provider: string, credentials: any }>()
);

export const signUpSuccess = createAction(
  '[Account] Sign Up Success'
);

export const signUpFailure = createAction(
  '[Account] Sign Up Failure',
  props<{ error: any }>()
);

export const authenticated = createAction(
  '[Account] Authenticated',
  props<{ user: User }>()
);

export const notAuthenticated = createAction(
  '[Account] Not Authenticated'
);

export const logout = createAction(
  '[Account] Log out'
);
